export default __webpack_public_path__ + "media/images/lp/payment-pc-429db5f380d50a2bc4bbee238dc2bc1e.jpg";